import React from 'react';
import {
	Box,
	ComposedElement,
	Typography,
	TypographyStyles,
	useTheme,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { Icons } from '@bcp-nextgen-dx-component-factory/accolade-design-system/dist/assets/MBCP';
import { rem } from '@helpers';

export interface StepperProps {
	parentIndex: number;
	text: string;
	wasFinished: boolean;
	isCurrentMenu: boolean;
}

/**
 * Stepper
 *
 * @todo If Accolade change disabled color of Typography change palette.global.ui8 to palette.global.ui9
 */
export const Stepper: React.FC<StepperProps> = ({ parentIndex, text, wasFinished, isCurrentMenu }) => {
	const { palette } = useTheme();

	return (
		<Box styles={{ alignItems: 'center' }}>
			{wasFinished ? (
				<ComposedElement
					icon={{ source: Icons.Check, svgProps: { fill: palette.primary.p1 } }}
					container={{
						styles: {
							backgroundColor: palette.background.b1,
							color: palette.background.b1,
							border: `2px solid ${palette.primary.p1}`,
						},
					}}
				/>
			) : (
				<ComposedElement
					text={{
						content: (parentIndex + 1).toString(),
						props: {
							alternativeStyleProperties: {
								color: !isCurrentMenu && !wasFinished ? palette.global.ui8 : palette.background.b1,
							},
						},
					}}
					container={{
						styles: {
							backgroundColor:
								!isCurrentMenu && !wasFinished ? palette.background.b1 : palette.primary.p1,
							color: !isCurrentMenu && !wasFinished ? palette.global.ui8 : palette.background.b1,
							border: !isCurrentMenu && !wasFinished ? `2px solid ${palette.global.ui8}` : undefined,
						},
					}}
				/>
			)}
			<Typography
				appearance={'subtitle-100-02'}
				colorsLevel={!isCurrentMenu && !wasFinished ? 'disabled' : undefined}
				styles={{ marginLeft: rem(16), wordBreak: 'break-all' } as TypographyStyles}
			>
				{text}
			</Typography>
		</Box>
	);
};
